<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMUserDataWorkplaceList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMUserDataWorkplaceForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMUserDataWorkplaceForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMUserDataWorkplaceForm,
    Loader
  },

  data () {
    return {
      item: {},
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmuserdataworkplace/update/isLoading',
      error: 'excmuserdataworkplace/update/error',
      deleteError: 'excmuserdataworkplace/del/error',
      deleteLoading: 'excmuserdataworkplace/del/isLoading',
      created: 'excmuserdataworkplace/create/created',
      deleted: 'excmuserdataworkplace/del/deleted',
      retrieved: 'excmuserdataworkplace/update/retrieved',
      updated: 'excmuserdataworkplace/update/updated',
      violations: 'excmuserdataworkplace/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.go(-1)
    },

    updated: function () {
      this.$router.go(-1)
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmuserdataworkplace/create/reset',
      deleteItem: 'excmuserdataworkplace/del/del',
      delReset: 'excmuserdataworkplace/del/reset',
      retrieve: 'excmuserdataworkplace/update/retrieve',
      updateReset: 'excmuserdataworkplace/update/reset',
      update: 'excmuserdataworkplace/update/update',
      updateRetrieved: 'excmuserdataworkplace/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmuserdataworkplace ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
